import React from "react";
import { useSearchParams } from "react-router-dom";
import { cadastrarUsuarioDistribuidor } from "../services/api";
import CadastroDistribuidorUsuario from "./CadastroDistribuidorUsuario";

const NovoDistribuidorUsuario = ({ token }) => {
  const [searchParams] = useSearchParams();
  const distribuidorId = searchParams.get("distribuidorId") || "";

  const handleSubmit = async (data) => {
    await cadastrarUsuarioDistribuidor(data.distribuidorId, data, token);
  };

  return (
    <CadastroDistribuidorUsuario
      token={token}
      onSubmit={handleSubmit}
      distribuidorIdFromQuery={distribuidorId}
    />
  );
};

export default NovoDistribuidorUsuario;
